import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { articleImages } from '@/mocks/articleImages';

export function FeaturedArticles() {
  const featuredArticles = articles.slice(0, 6);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-10 md:mb-14 gap-3">
          <div>
            <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">
              精选文章
            </h2>
            <p className="text-sm text-foreground-600">
              深入解读韩国伦理文化的核心议题
            </p>
          </div>
          <Link
            to="/category/ru-jia-lun-li"
            className="text-sm text-accent-600 hover:text-accent-700 font-medium flex items-center gap-1 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-accent-300 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={articleImages[article.slug]}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <div className="flex items-center gap-3 text-xs text-foreground-500 mb-3 flex-wrap">
                  <span className="bg-accent-100 text-accent-700 px-2 py-0.5 rounded-full">
                    {article.categoryName}
                  </span>
                  <span>{article.readTime}</span>
                </div>
                <h3 className="text-sm md:text-base font-semibold font-heading text-foreground-950 mb-2 group-hover:text-accent-600 transition-colors duration-200 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2 flex-1">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between mt-4 pt-3 border-t border-background-200">
                  <span className="text-xs text-foreground-500">{article.author}</span>
                  <span className="text-xs text-foreground-400">{article.publishDate}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}